import axios from "axios";

export default class HttpRequests{

    login(code,password){

        return axios.post('/student/login',{code,password})

    }

    loginWithToken(){

        return axios.get('/student/loginWithToken')
    }
    logOut(){

      return axios.post('/student/logOut')
   }

   getSchedule(){

      return axios.get('/student/getSchedule')

   }

   getEvaluations(){
      return axios.get('/student/getEvaluations')
   }


   getBooksFromMyug(){
      return axios.get('/student/getBooksFromMyug')
   }
   
   downloadFile(file){

      return axios.post('/student/downloadFile',{file},{responseType:'blob'})
  
       
  
    }

    getApplicationTemplates(){
      return axios.get('/student/getApplicationTemplates')
    }

    getModules(){
      return axios.get('/student/getModules')
    }
    

    sentApplication(chosenTemplate,applicationInputID,applicationInputInfo,freeText){

         return axios.post('/student/sentApplication',{chosenTemplate,applicationInputID,applicationInputInfo,freeText})

    }

    getMyApplications(){
      return axios.get('/student/getMyApplications')
    }

}